"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const currency_1 = require("../../../../app/shared/utils/currency");
exports.default = (0, vue_1.defineComponent)({
    __name: 'insurance-card',
    props: {
        title: null,
        price: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const props = __props;
        const fixedTitle = (0, vue_2.computed)(() => {
            const titles = {
                "Aba Seguros": "Chubb",
                "Zurich M\u00E9xico": "Zurich",
                "Grupo Nacional Provincial": "GNP",
            };
            return titles[props.title] ?? props.title;
        });
        const handleClick = () => {
            emit("click");
        };
        return { __sfc: true, props, fixedTitle, emit, handleClick, parseToMexicanPeso: currency_1.parseToMexicanPeso };
    }
});
